import { Button, Flex } from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import { type IYacht } from "src/pages/Management/Clients/Organizations/Yachts/Yacht.types";
import { StyledTd, StyledTr } from "src/styled";
import { setYachtId } from "src/utils";
import { getStatus } from "../ManagementTable/ManagementTable.utils";

interface Props {
  row: IYacht;
}

const FleetYachtsRow = ({ row }: Props) => {
  const navigate = useNavigate();
  const viewUrl = `/management/yachts/yacht/${row.yid}`;
  return (
    <StyledTr
      hover
      onClick={() => navigate(viewUrl)}
      style={{ cursor: "pointer" }}>
      <StyledTd>{row.yachtname}</StyledTd>
      <StyledTd>{/* Account manager */}</StyledTd>
      <StyledTd>{/* Sub start */}</StyledTd>
      <StyledTd>{/* Last accesed */}</StyledTd>

      <StyledTd center>{row.open}</StyledTd>
      <StyledTd center>{getStatus(row.active)}</StyledTd>

      <StyledTd center style={{ width: 200 }}>
        <Flex gap={"10px"}>
          {/* <Button */}
          {/*   component={Link} */}
          {/*   to={`/settings/yacht-set-up`} */}
          {/*   w="90%" */}
          {/*   variant="outline" */}
          {/*   onClick={e => { */}
          {/*     e.stopPropagation(); */}
          {/*     setYachtId(row.yid); */}
          {/*   }}> */}
          {/*   Edit */}
          {/* </Button> */}
          <Button component={Link} to={viewUrl} w="90%" variant="outline">
            View
          </Button>
        </Flex>
      </StyledTd>
    </StyledTr>
  );
};

export default FleetYachtsRow;
